import React from 'react';
import Experiments from '@wix/wix-experiments';
import { PureExperimentsProvider } from '@wix/wix-experiments-react';

function lazy<T>(initFunc: (scope: string) => T) {
  let value: T;
  return (scope: string) => {
    if (!value) {
      value = initFunc(scope);
    }

    return value;
  };
}

const experimentsLazy = lazy(
  (scope: string) =>
    new Experiments({
      scope,
    }),
);

export const ExperimentsProvider: React.FC<{
  scope: string;
  children?: React.ReactNode;
}> = ({ scope, children }) => {
  return (
    <PureExperimentsProvider experiments={experimentsLazy(scope)}>
      {children}
    </PureExperimentsProvider>
  );
};
